import { createSelector, DuckSelector } from '@atc/modular-redux';
import inventoryDuckSelectors from '../inventoryDuckCreator/inventoryDuckSelectors.js';
export default () => ({
  getSavedInventories: new DuckSelector(selectors => state => selectors.getDuckState(state).inventory),
  getSavedInventoryIds: new DuckSelector(selectors => createSelector(selectors.getSavedInventories, function (inventories) {
    if (inventories === void 0) {
      inventories = [];
    }
    return inventories.map(listing => {
      if (typeof listing === 'object') {
        return listing.listingId;
      }
      return listing;
    });
  })),
  hasMaxQuickSaveItems: new DuckSelector(selectors => createSelector(selectors.getSavedInventoryIds, state => state.savedInventory.maxQuickSavesLimit, (inventory, limit) => inventory.length >= limit)),
  getSavedInventory: new DuckSelector(selectors => createSelector(inventoryDuckSelectors.getInventory, selectors.getSavedInventoryIds, (inventory, savedInventoryIds) => savedInventoryIds.reduce((acc, id) => {
    const item = inventory[id];
    if (item) {
      acc.push(item);
    }
    return acc;
  }, []))),
  getSavedInventoryCount: new DuckSelector(selectors => createSelector(selectors.getSavedInventoryIds, ids => ids.length)),
  getUpdateSavedInventoryState: new DuckSelector(() => createSelector(state => state.savedInventory.showUpdateSavedInventory, state => state.savedInventory.updateSavedInventory, state => state.savedInventory.animatedButtonState, function (show, updateSavedInventoryState, animatedButtonState) {
    if (updateSavedInventoryState === void 0) {
      updateSavedInventoryState = {};
    }
    return {
      bookmark: updateSavedInventoryState.bookmark,
      listing: updateSavedInventoryState.listing,
      phone: updateSavedInventoryState.phone,
      messages: updateSavedInventoryState.messages,
      show,
      animatedButtonState
    };
  })),
  getSavedInventoryAlert: new DuckSelector(selectors => state => selectors.getDuckState(state).globalAlert),
  getAnimatedButtonState: new DuckSelector(selectors => state => selectors.getDuckState(state).animatedButtonState)
});